import VueRouter, { Route } from 'vue-router'

// It prevents from Uncaught (in promise) Error: Redirected from "/login" to "/" via a navigation guard.
// When on page A, and click on a button to take you to page B  { router.push('/B'); } on page.
// But there is a Navigation Guard for page B, that sends you to page C.
// This error is a way for letting that goToB() function know that the router hasn't been able to fulfill the desired task, and the user hasn't landed on /B.
// https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a

export const routerPush = async (router: VueRouter, path: string): Promise<Route | void> => {
  return router.push(path).catch(() => {})
}

export function openInNewTab(link: string): Window | null {
  return window.open(link, 'link', 'noreferrer noopener')
}
